import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import Section from "../Section";
import { Box, Switch, FormControlLabel } from "@material-ui/core";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
addRegisteredSectionLayout({
    name: "ToggleLiteralSection",
    displayName: "ToggleLiteralSection",
    settings: {}
});
const ToggleLiteralSection = (props) => {
    const { className, fields } = props;
    const [literalToggled, setLiteralToggled] = useState(props.literal);
    const toggleLiteral = useCallback(() => setLiteralToggled(x => !x), []);
    if (fields.length === 0)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Section, { ...props, literal: literalToggled }), _jsx(Box, { className: className, display: "flex", justifyContent: "center", children: _jsx(FormControlLabel, { control: _jsx(Switch, { color: "primary", checked: !literalToggled || false, value: !literalToggled, onChange: toggleLiteral }), label: "Gjør endringer" }) })] }));
};
ToggleLiteralSection.displayName = "DployToggleLiteralSection";
export { ToggleLiteralSection };
//# sourceMappingURL=ToggleLiteralSection.js.map